import Http from "@/libraries/Http"; 

export default {
    apiVersion: 'v1', 
    RESTroute: 'contract-stats',

    async GET_latest(stat_group, params = {}) {
        return Http.get(`/${this.apiVersion}/${this.RESTroute}/get-latest/${stat_group}`, {params: params}); 
    },

    async GET_groups() {
        return {
            'faa-de': 'Aktiver (DE)',
            'faa-meg': 'Aktiver (MEG)'
        };
    },

    /** 
     * Get all resources 
     * GET /resource
     */
    async GET(stat_group, params = {}) {
        return Http.get(`/${this.apiVersion}/${this.RESTroute}/get-group/${stat_group}`, {params: params}); 
    }, 
     
    /** 
     * Get single resource
     * GET /resource/<id>
     */
    async GETS(id, params = {}) {
        return Http.get(`/${this.apiVersion}/${this.RESTroute}/${id}`, {params: params}); 
    }, 

    /** 
     * Create resource
     * POST /resource 
     * Payload: {}
     */
    async POST(data) {
        return Http.post(`/${this.apiVersion}/${this.RESTroute}`, data);
    },

    /** 
     * Put resource
     * PUT /resource/<id>
     * Payload: {}
     */
    async PUT(data) {        
        return Http.put(`/${this.apiVersion}/${this.RESTroute}/${data.id}`, data);
    }, 

    /** 
     * Delete resource
     * DELETE /resource/<id>
     */
    async DELETE(id) {
        return Http.delete(`/${this.apiVersion}/${this.RESTroute}/${id}`);
    }
    
}
